import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import i18n from 'src/utils/translate';
import InformationCard from 'src/components/informationCard';
import { PrimaryButton } from 'styles-js/buttons';

const Title = styled.p`
  font-weight: bold;
  margin-bottom: 10px;
`;

const Paragraph = styled.p`
  margin-bottom: 10px;
`;

const CommunityMembersSearchSidebar = () => {
  return (
    <InformationCard>
      <Title>{i18n.t('Interested in connecting with others?')}</Title>
      <Paragraph>{i18n.t('Profiles are one of the most viewed pages on HealthUnlocked. Update your profile to help people get to know you.')}</Paragraph>
      <Link
        legacyBehavior
        passHref
        as={'/profile/edit'}
        href={'/user/editProfile'}
      >
        <PrimaryButton as="a">{i18n.t('Update your profile')}</PrimaryButton>
      </Link>
    </InformationCard>
  );
};

export default CommunityMembersSearchSidebar;
